/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgMsgSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 40 40"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} fill="currentColor" rx={20} />
    <path
      fill="#fff"
      d="M12.668 11.763A10.975 10.975 0 0 1 16.564 9.5 4.394 4.394 0 0 0 20 11.16a4.374 4.374 0 0 0 3.436-1.66 10.976 10.976 0 0 1 3.896 2.263 4.43 4.43 0 0 0 1.617 5.258c.545.374 1.167.62 1.82.719a11.15 11.15 0 0 1 0 4.52 4.395 4.395 0 0 0-3.15 2.16 4.429 4.429 0 0 0-.287 3.817 10.976 10.976 0 0 1-3.896 2.262A4.395 4.395 0 0 0 20 28.84a4.375 4.375 0 0 0-3.436 1.66 10.975 10.975 0 0 1-3.896-2.262 4.43 4.43 0 0 0-1.617-5.258 4.38 4.38 0 0 0-1.82-.719 11.148 11.148 0 0 1 0-4.52 4.38 4.38 0 0 0 3.15-2.16 4.427 4.427 0 0 0 .287-3.817v-.001ZM21.65 22.87a3.304 3.304 0 0 0 1.553-2.013 3.33 3.33 0 0 0-1.18-3.502 3.294 3.294 0 0 0-2.451-.65 3.274 3.274 0 0 0-1.222.424 3.313 3.313 0 0 0-1.52 2.012 3.328 3.328 0 0 0 .332 2.505 3.288 3.288 0 0 0 4.488 1.224Z"
    />
  </svg>
)
const Memo = memo(SvgMsgSettings)
export default Memo
